export default "__VITE_ASSET__BXR4rYe1__"